import {
  FETCH_JOB_PORTAL_JOB_LIST,
  FETCH_JOB_PORTAL_JOB_LIST_SUCCESS,
  FETCH_JOB_PORTAL_JOB_LIST_FAILURE,
  RESET_JOB_PORTAL_JOB_LIST,
  FETCH_JOB_PORTAL_JOB,
  FETCH_JOB_PORTAL_JOB_SUCCESS,
  FETCH_JOB_PORTAL_JOB_FAILURE,
  RESET_FETCH_JOB_PORTAL_JOB_ERROR,
  FETCH_JOB_PORTAL_WORK_LOCATIONS,
  FETCH_JOB_PORTAL_WORK_LOCATIONS_SUCCESS,
  FETCH_JOB_PORTAL_WORK_LOCATIONS_FAILURE,
  PARSE_JOB_PORTAL_RESUME,
  PARSE_JOB_PORTAL_RESUME_SUCCESS,
  PARSE_JOB_PORTAL_RESUME_FAILURE,
  RESET_JOB_PORTAL_RESUME,
  POST_JOB_PORTAL_JOB_APPLICATION,
  POST_JOB_PORTAL_JOB_APPLICATION_SUCCESS,
  POST_JOB_PORTAL_JOB_APPLICATION_FAILURE,
  SELECT_JOB_PORTAL_JOB,
  RESET_JOB_PORTAL_SELECTED_JOB,
  SET_SEARCH_VALUES,
  SET_FILTER_VALUES,
  SET_WORKMODE_FILTER,
  SET_LOCATION_FILTER,
  SET_JOBTYPE_FILTER,
  SET_PAGE_NUMBER,
  SET_DIV_SCROLL_Y_POSITION,
  SET_WINDOW_SCROLL_Y_POSITION,
  SET_SUCCESS_STATE,
  FETCH_JOB_PORTAL_JOB_NO_FILTER,
  FETCH_JOB_PORTAL_JOB_NO_FILTER_SUCCESS,
  FETCH_JOB_PORTAL_JOB_NO_FILTER_FAILURE,
} from "./actionTypes";

export const fetchJobPortalJobList = (page) => ({
  type: FETCH_JOB_PORTAL_JOB_LIST,
  payload: page,
});

export const fetchJobPortalJobListSuccess = (jobs) => ({
  type: FETCH_JOB_PORTAL_JOB_LIST_SUCCESS,
  payload: jobs,
});

export const fetchJobPortalJobListFailure = (error) => ({
  type: FETCH_JOB_PORTAL_JOB_LIST_FAILURE,
  payload: error,
});

export const resetJobPortalJobList = () => ({
  type: RESET_JOB_PORTAL_JOB_LIST,
});

export const fetchJobPortalJob = (jobId) => ({
  type: FETCH_JOB_PORTAL_JOB,
  payload: jobId,
});

export const fetchJobPortalJobSuccess = (job) => ({
  type: FETCH_JOB_PORTAL_JOB_SUCCESS,
  payload: job,
});

export const fetchJobPortalJobFailure = (error) => ({
  type: FETCH_JOB_PORTAL_JOB_FAILURE,
  payload: error,
});

export const resetFetchJobPortalJobError = () => ({
  type: RESET_FETCH_JOB_PORTAL_JOB_ERROR,
});

export const fetchJobPortalWorkLocations = () => ({
  type: FETCH_JOB_PORTAL_WORK_LOCATIONS,
});

export const fetchJobPortalWorkLocationsSuccess = (locations) => ({
  type: FETCH_JOB_PORTAL_WORK_LOCATIONS_SUCCESS,
  payload: locations,
});

export const fetchJobPortalWorkLocationsFailure = (error) => ({
  type: FETCH_JOB_PORTAL_WORK_LOCATIONS_FAILURE,
  payload: error,
});

export const parseJobPortalResume = (formData) => ({
  type: PARSE_JOB_PORTAL_RESUME,
  payload: formData,
});

export const parseJobPortalResumeSuccess = (resumeData) => ({
  type: PARSE_JOB_PORTAL_RESUME_SUCCESS,
  payload: resumeData,
});

export const parseJobPortalResumeFailure = (error) => ({
  type: PARSE_JOB_PORTAL_RESUME_FAILURE,
  payload: error,
});

export const resetJobPortalResume = () => ({
  type: RESET_JOB_PORTAL_RESUME,
});

export const postJobPortalJobApplication = (formData, jobId) => ({
  type: POST_JOB_PORTAL_JOB_APPLICATION,
  payload: { formData, jobId },
});

export const postJobPortalJobApplicationSuccess = () => ({
  type: POST_JOB_PORTAL_JOB_APPLICATION_SUCCESS,
});

export const postJobPortalJobApplicationFailure = (error) => ({
  type: POST_JOB_PORTAL_JOB_APPLICATION_FAILURE,
  payload: error,
});

export const selectJobPortalJob = (job) => ({
  type: SELECT_JOB_PORTAL_JOB,
  payload: job,
});

export const resetJobPortalSelectedJob = () => ({
  type: RESET_JOB_PORTAL_SELECTED_JOB,
});

export const setSearchValues = (search, value) => ({
  type: SET_SEARCH_VALUES,
  payload: { search, value },
});

export const setFilterValues = (filter) => ({
  type: SET_FILTER_VALUES,
  payload: filter,
});

export const setWorkModeFilter = (mode) => ({
  type: SET_WORKMODE_FILTER,
  payload: mode,
});

export const setLocationFilter = (location) => ({
  type: SET_LOCATION_FILTER,
  payload: location,
});

export const setJobTypeFilter = (type) => ({
  type: SET_JOBTYPE_FILTER,
  payload: type,
});

export const setPageNumber = (page) => ({
  type: SET_PAGE_NUMBER,
  payload: page,
});

export const setDivScrollYPosition = (position) => ({
  type: SET_DIV_SCROLL_Y_POSITION,
  payload: position,
});

export const setWindowScrollYPosition = (position) => ({
  type: SET_WINDOW_SCROLL_Y_POSITION,
  payload: position,
});

export const setSuccessState = (boo) => ({
  type: SET_SUCCESS_STATE,
  payload: boo,
});

export const fetchJobPortalJobNoFilter = (jobId) => ({
  type: FETCH_JOB_PORTAL_JOB_NO_FILTER,
  payload: jobId,
});

export const fetchJobPortalJobNoFilterSuccess = (job) => ({
  type: FETCH_JOB_PORTAL_JOB_NO_FILTER_SUCCESS,
  payload: job,
});

export const fetchJobPortalJobNoFilterFailure = (error) => ({
  type: FETCH_JOB_PORTAL_JOB_NO_FILTER_FAILURE,
  payload: error,
});

